module.exports = __webpack_public_path__ + "img/logo-tray.6f903e29.svg";